import React from 'react'

class NameInput extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);

        this.state = {
            value: ''
        }
    }

    /**
     * Remove forbidden characters
     * @param e
     */
    onChange(e) {
        const { value } = e.target;

        if(!this.isASCII(value)) {
            return;
        }

        const forbiddenChars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

        let containsForbiddenChar = false;

        forbiddenChars.forEach(char=>{
            if(value.indexOf(char) > -1) {
                containsForbiddenChar = true;
            }
        });

        if(containsForbiddenChar) {
            return;
        }

        this.setState({ value });
        this.props.onChange(value);
    }

    /**
     * Check if the given string contains only ASCII characters
     * @param str
     * @returns {boolean}
     */
    isASCII(str) {
        return /^[\x00-\x7F]*$/.test(str);
    }

    onBlur(e) {
        this.props.onBlur && this.props.onBlur(e.target.value);
    }

    render() {
        const { value } = this.state;

        return (
            <div className={['input-container', value.length === 0 ? 'is-empty' : ''].join(' ')}>
                <label htmlFor={this.props.id} className="text-nowrap">
                    {this.props.placeholder}
                </label>
                <input className="form-control"
                       type="text"
                       id={this.props.id}
                       value={value}
                       onChange={this.onChange}
                       onBlur={this.onCardBlur}
                       placeholder={this.props.placeholder}
                       autoComplete="cc-name"
                       autoCorrect="off"
                       spellCheck="false"
                />

            </div>
        )
    }
}

export default NameInput;



// WEBPACK FOOTER //
// ./src/components/NameInput/index.js